module.exports = __webpack_public_path__ + "static/media/boop.9adc6923.mp3";